import { useState } from "react";
import { LINKS } from "../../constants/constants";
import "./Contact.scss"

export default function Contact() {

    const [ gmailCopied, setGmailCopied ] = useState(false);
    const [ phoneCopied, setPhoneCopied ] = useState(false);
    const [ skypeCopied, setSkypeCopied ] = useState(false);

    const handleCopyToClipBoard = (link, media) => {
        navigator.clipboard.writeText(link)
        if (!gmailCopied && media==="Gmail") {
            setGmailCopied(true)
            setTimeout(() => {
                setGmailCopied(false)
            }, 3000);
        } else if(!phoneCopied && media==="Phone") {
            setPhoneCopied(true)
            setTimeout(() => {
                setPhoneCopied(false)
            }, 3000);
        } else if(!skypeCopied && media==="Skype") {
            setSkypeCopied(true)
            setTimeout(() => {
                setSkypeCopied(false)
            }, 3000);
        }
    }

    return (
        <div className="contact-section row">
            <div className="right-section d-flex justify-content-center flex-column col-12 col-sm-6">
                <h1 className="text-uppercase">I'd Love to Hear from You!</h1>
            </div>
            <div className="left-section d-flex justify-content-center align-items-sm-end flex-column col-12 col-sm-6">
                <div 
                    className="btn btn-outline-primary mb-2"
                    role="button" 
                    onClick={() =>  handleCopyToClipBoard(LINKS.GMAIL, "Gmail")}
                >
                    { gmailCopied ? 'copied' : 'dinusenal8@gmail.com' }
                </div>
                <div 
                    className="btn btn-outline-primary mb-2"
                    role="button" 
                    onClick={() =>  handleCopyToClipBoard(LINKS.PHONE, "Phone")}
                >
                    { phoneCopied ? 'copied' : 'Phone' }
                </div>
                <div 
                    className="btn btn-outline-primary mb-2"
                    role="button" 
                    onClick={() =>  handleCopyToClipBoard(LINKS.SKYPE, "Skype")}
                >
                    { skypeCopied ? 'copied' : 'Skype' }
                </div>
                <a  
                    className="btn btn-outline-primary mb-2"
                    role="button" 
                    href={LINKS.GITHUB}
                    target="_blank"
                    rel="noreferrer"
                >
                    GitHub
                </a>
                <a  
                    className="btn btn-outline-primary mb-2"
                    role="button" 
                    href={LINKS.LINKEDIN}
                    target="_blank"
                    rel="noreferrer"
                >
                    Linkedin
                </a>
                <a  
                    className="btn btn-outline-primary mb-2"
                    role="button" 
                    href={LINKS.CV}
                    target="_blank"
                    rel="noreferrer"
                >
                    CV
                </a>
                <a 
                    className="btn btn-outline-primary"
                    role="button" 
                    href={LINKS.INSTAGRAM}
                    target="_blank"
                    rel="noreferrer"
                >
                    Instagram
                </a>
            </div>
            <h4 className="fw-light text-uppercase text-center mt-3 mt-sm-0">
                DESIGNED AND DEVELOPED BY DINU SENAL @2022
            </h4>
        </div>
    )
}